import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../BaseModule/Components/BaseModal/BaseModal';
import AddFamilyMember from './AddFamilyMember';
import { Size } from '../../../../Enums/Size.enum';
import { useAppContext } from '../../../../Services/AppContext';

const AddFamilyMemberModal: React.FC<BaseModalProps> = props => {
	const { partnerId } = useAppContext();

	return (
		<BaseModal
			{...props}
			title={
				partnerId === 21
					? 'component.userFamily.whoYouWannaAddToGroup'
					: 'component.userFamily.whoYouWannaAddToFamily'
			}
			size={Size.SM}
		>
			<AddFamilyMember />
		</BaseModal>
	);
};

export default AddFamilyMemberModal;
